import { createStore } from 'redux'

const initialState = {
  sidebarShow: true,
  asideShow: false,
  theme: 'default',
  user: {},
  generalSettings: {},
  toastMessage: {
    isError: false,
    isShown: false,
    color: 'primary',
    text: ''
  },
  isLoading: false,
  isSuccessVerifyUser: false,
  showPopUpBanner: false,
}

const changeState = (state = initialState, { type, ...rest }) => {
  switch (type) {
    case 'set':
      return { ...state, ...rest }
    case 'SET_USER':
      return { ...state, ...rest }
    case 'SET_GENERAL_SETTING':
      return { ...state, ...rest }
    case 'SET_TOAST_MESSAGE':
      return { ...state, ...rest }
    case "SET_IS_SUCCESS_VERIFY_USER":
      return { ...state, ...rest };
    case "SET_SHOW_POP_UP_BANNER":
      return { ...state, ...rest };
    case 'SET_IS_LOADING':
      return { ...state, ...rest }
    default:
      return state
  }
}

const store = createStore(changeState)
export default store
